export default "__VITE_ASSET__Bgl_et0R__"